import authImage from "../assets/images/authSvg.svg";
import logo from "assets/images/logoSvg.svg";
import { adminRoutePath } from "config/routeMgt/adminRoutePath";
import { Navigate } from "react-router-dom";
import "../assets/style.css";
import { SignInForm } from "../components/SignInForm";
import { useIsAuthenticated } from "react-auth-kit";

export const AdminSignIn = () => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      {isAuthenticated() && (
        <Navigate to={adminRoutePath.home} replace={true} />
      )}
      <div className="grid grid-cols-1 lg:grid-cols-2 h-screen overflow-auto">
        <div className="Container py-3 bg-white">
          <div className="mt-2">
            <a
              href="https://www.arnopro.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={logo} alt="logo" />
            </a>
          </div>
          <div className="flex justify-center mt-10">
            <div className="authFormWrap">
              <div className="mb-6">
                <h2 className="text-2xl font-bold pb-1 text-primary">
                  Admin Sign in
                </h2>
                <p className="text-accent text-sm">
                  Welcome back! Please enter your details.
                </p>
              </div>
              <SignInForm />
            </div>
          </div>
        </div>
        <div className="bg-primary h-screen Container lg:flex items-center justify-center hidden w-full sticky top-0">
          <img src={authImage} />
        </div>
      </div>
    </>
  );
};
